import { render } from "./DevOptions.vue?vue&type=template&id=6d8b99e2&ts=true"
import script from "./DevOptions.vue?vue&type=script&lang=ts"
export * from "./DevOptions.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__